<template>
  <section class="page-copy">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <h1>1616 SE 8th Street<br>
          Fort Lauderdale Florida 33316<br>
          954-300-4445<br>
          corp@opencabana.com</h1>
        </div><!-- end .col-md-12 -->
      </div><!-- end .row -->
    </div><!-- end .container -->
  </section>
</template>

<script>
export default {
  name: 'Contact',
  data() {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// contact.vue?1323b216